export default "__VITE_ASSET__CozO8PMU__"